import React from 'react';
import { useDispatch } from 'react-redux';
import { TDoneVoteRating, TVoteRating } from '../../../../store/interactive/types';
import { TRoom } from '../../../../store/sockets/types';
import { CheckDoneVoteRating, SendVoteRating } from '../../../../store/interactive/actions';
import { Success } from '../../../../test/screens/Sucess';
import { Polls } from './Polls';
import { PollResult } from './PollResult';
import { PollsWithTimer } from './PollsWithTimer';

interface VoteRatingProps {
  vote: TVoteRating;
  room: TRoom;
  disabled: boolean;
  doneVoteRating: TDoneVoteRating | null;
}

export const VoteRating: React.FC<VoteRatingProps> = ({ vote, room, disabled, doneVoteRating }) => {
  const [seconds, setSeconds] = React.useState(0);

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (vote.timeout && vote.startTime) {
      setSeconds(Math.round(vote.timeout - (Number(new Date()) - Number(new Date(vote.startTime))) / 1000));
    }
  }, [vote]);

  React.useEffect(() => {
    let timer: NodeJS.Timeout;
    if (seconds > 0) {
      timer = setInterval(() => setSeconds(seconds - 1), 1000);
    }
    return () => clearInterval(timer);
  }, [seconds]);

  React.useEffect(() => {
    if (room && vote.isFinish === 2) {
      dispatch(
        CheckDoneVoteRating.request({
          data: {
            voteId: vote.id,
            event_id: room.event_id,
            roomId: room.absnum,
          },
        })
      );
    }
  }, [dispatch, vote, room]);

  const sendValue = (value: number) => {
    const isDis = disabled || value === 0;
    if (!isDis) {
      dispatch(
        SendVoteRating.request({
          data: {
            answerId: value,
            voteId: vote.id,
            event_id: room.event_id,
            roomId: room.absnum,
          },
        })
      );
    }
  };

  if (!doneVoteRating) {
    return null;
  }

  if (vote.isFinish === 3 || vote.isFinish === 1) {
    return (
      <div style={{ color: 'green', margin: '20px', textAlign: 'center' }}>
        {<span>{vote.isFinish === 1 ? 'Голосування не розпочато' : 'Голосування завершено'}</span>}
      </div>
    );
  }

  if (doneVoteRating?.done) {
    return (
      <Success>
        <PollResult needBalls={doneVoteRating.total} balls={doneVoteRating.points} success={doneVoteRating.points > 0} />
      </Success>
    );
  }

  return (
    <>
      {vote.timeout ? (
        <PollsWithTimer disabled={disabled} seconds={seconds} vote={vote} sendValue={sendValue} />
      ) : (
        <Polls type="pass" vote={vote} disabled={disabled} sendValue={sendValue} />
      )}
    </>
  );
};
